/* ============================================================================
   URIC ACID PURGE — comportamiento compartido de las secciones.
   Se carga desde cada sección; el guard de abajo evita que corra dos veces.
   ============================================================================ */
(function () {
  if (window.__lpInit) return;
  window.__lpInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- reveal on scroll ---------------------------------------------------
     La landing original marcaba <body class="anim"> y observaba los .rv.
     Acá el contenedor de cada sección hace de body. */
  function initReveal(root) {
    var page = root.querySelector('.lp-page');
    if (!page) return;
    if (reduce) return;
    page.classList.add('anim');
    var items = page.querySelectorAll('.rv');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* --- selector de packs --------------------------------------------------
     Marca visualmente el .pack elegido y sincroniza el precio de la barra
     sticky con la variante seleccionada. */
  function initPacks(root) {
    var form = root.querySelector('[data-lp-packs]');
    if (!form) return;
    var packs = form.querySelectorAll('.pack');
    var oculto = form.querySelector('[data-lp-variante]');

    function sync() {
      var elegido = null;
      packs.forEach(function (p) {
        var radio = p.querySelector('input[type="radio"]');
        var on = radio && radio.checked;
        p.classList.toggle('sel', !!on);
        if (on) elegido = p;
      });
      if (!elegido) return;

      /* La variante viaja en el input oculto name="id" — es lo que leen
         Releasit y cualquier otra app de checkout. Los radios son solo la UI:
         si una app leyera [name="id"] sobre un grupo de radios se quedaría con
         el primero y mandaría siempre el primer pack. */
      var radio = elegido.querySelector('input[type="radio"]');
      if (oculto && radio && oculto.value !== radio.value) {
        oculto.value = radio.value;
        /* Avisar a las apps que escuchan el formulario de producto. */
        oculto.dispatchEvent(new Event('change', { bubbles: true }));
        oculto.dispatchEvent(new Event('input', { bubbles: true }));
      }

      var precio = elegido.getAttribute('data-precio') || '';
      document.querySelectorAll('[data-lp-sticky-precio]').forEach(function (el) {
        el.textContent = precio;
      });
    }

    packs.forEach(function (p) {
      var radio = p.querySelector('input[type="radio"]');
      if (radio) radio.addEventListener('change', sync);
    });
    sync();

    /* Solo cuando se vende por el checkout de Shopify en vez de Releasit:
       /cart/{variante}:1 REEMPLAZA el carrito y cae directo en el checkout,
       para que nada que el cliente tuviera guardado se cuele en el pedido. */
    if (form.hasAttribute('data-lp-directo')) {
      form.addEventListener('submit', function (ev) {
        if (!oculto || !oculto.value) return;
        ev.preventDefault();
        window.location.href = '/cart/' + oculto.value + ':1';
      });
    }
  }
  /* ── Tarjetas de oferta: abren el formulario de Releasit ─────────────
     Las tarjetas son escaparate y no eligen nada. Su boton busca el boton de
     Releasit de la misma seccion y lo pulsa; si por lo que sea no esta (la app
     todavia no monto, la quitaron), hace scroll hasta donde deberia estar para
     que el cliente no quede sin salida. Delegado en document: sirve igual si la
     seccion se re-renderiza desde el editor.                                  */
  function botonReleasit(desde) {
    var seccion = desde.closest('#pedido') || document;
    var b = seccion.querySelector('#rsi_buy_now_button, [id^="rsi_buy_now_button"], .rsi_buy_now_button');
    if (b) return b;
    return document.querySelector('#pedido #rsi_buy_now_button, #pedido .rsi_buy_now_button');
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target.closest ? ev.target.closest('[data-lp-abrir]') : null;
    if (!t) return;
    ev.preventDefault();
    var b = botonReleasit(t);
    if (b) { b.click(); return; }
    var caja = document.querySelector('#pedido .lp-boton-app') || document.getElementById('pedido');
    if (caja) caja.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  function boot() {
    initReveal(document);
    initPacks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* El editor de temas re-renderiza secciones sin recargar la página. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    var page = root.querySelector('.lp-page');
    if (page && !reduce) {
      page.classList.add('anim');
      page.querySelectorAll('.rv').forEach(function (el) { el.classList.add('on'); });
    }
    initPacks(root);
  });
})();
